module.exports = __webpack_public_path__ + "img/Missing Halo Stone.eb8cb5eb.png";